module.exports = __webpack_public_path__ + "/images/cover-retailers-box-int.656cac8.webp";